module.exports = __webpack_public_path__ + "0357d400a523d5389b7927b05c9e7a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/usa_icon.png
// module id = 1226
// module chunks = 0